
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiDatiDialog extends Serenity.EntityDialog<UtentiDatiRow, any> {
        protected getFormKey() { return UtentiDatiForm.formKey; }
        protected getIdProperty() { return UtentiDatiRow.idProperty; }
        protected getLocalTextPrefix() { return UtentiDatiRow.localTextPrefix; }
        protected getNameProperty() { return UtentiDatiRow.nameProperty; }
        protected getService() { return UtentiDatiService.baseUrl; }
        protected getDeletePermission() { return UtentiDatiRow.deletePermission; }
        protected getInsertPermission() { return UtentiDatiRow.insertPermission; }
        protected getUpdatePermission() { return UtentiDatiRow.updatePermission; }

        protected form = new UtentiDatiForm(this.idPrefix);

    }
}